import React from "react";
import { Container, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import useCources from "../../../hooks/useCources";
import HeroSection from "../../Common/HeroSection/HeroSection";
import SingleCourseDetails from "./SingleCourseDetails/SingleCourseDetails";
import SingleCourse from "./SingleCourses/SingleCourse";

const Courses = () => {

  const [course] = useCources();

  return (
    <div>
      <HeroSection name={"Classes"}></HeroSection>

      <Container fluid>
        <Container>
          <Row>
            <h3 className="trainer-section-title1">Practice</h3>
            <h3 className="trainer-section-title2">
              Home And On-The-Go Classes
            </h3>
          </Row>
          <Row>
            {course.map((crs) => (
              <SingleCourse
                key={crs.id}
                data={crs}
              ></SingleCourse>
            ))}
          </Row>
        </Container>
      </Container>
    </div>
  );
};

export default Courses;
